/* video-thumb.js — fills placeholder posters with the video's own thumbnail.
   Liquid can't call Vimeo, so snippets/video-thumb.liquid emits gray
   placeholders tagged data-video-thumb (Vimeo id [+ unlisted hash]) and this
   script resolves them to the video's default frame. Primary source is Vimeo's
   public oEmbed endpoint (CORS-open, no token, works for unlisted links with
   the hash). If that returns nothing or fails, we fall back to vumbnail.com's
   static Vimeo thumbnail so the poster still shows the real frame instead of a
   gray box. The placeholder only stays if BOTH sources fail, so there's never a
   broken image. */
(function () {
  var spans = document.querySelectorAll('[data-video-thumb]');
  if (!spans.length) return;

  /* Swap the gray placeholder <span> for a loaded <img>. Only replaces once the
     image actually loads, so a dead URL never leaves a broken image. */
  function swap(span, src) {
    var img = document.createElement('img');
    img.alt = span.getAttribute('data-video-thumb-alt') || '';
    img.loading = 'lazy';
    img.className = span.className.replace(/\bplaceholder\b/, '').trim();
    img.onload = function () { if (span.isConnected) span.replaceWith(img); };
    img.onerror = span._vtFallback || null;
    img.src = src;
  }

  spans.forEach(function (span) {
    var id = span.getAttribute('data-video-thumb');
    var hash = span.getAttribute('data-video-thumb-hash');
    var link = 'https://vimeo.com/' + id + (hash ? '/' + hash : '');

    /* Last-resort static thumbnail if oEmbed yields nothing. */
    span._vtFallback = function () { swap(span, 'https://vumbnail.com/' + id + '.jpg'); };

    fetch('https://vimeo.com/api/oembed.json?width=1280&url=' + encodeURIComponent(link))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        if (!data.thumbnail_url) { span._vtFallback(); return; }
        /* oEmbed returns a sized thumb (…_295x166); ask the CDN for a wide one. */
        swap(span, data.thumbnail_url.replace(/_[0-9]+x[0-9]+(?=[.?]|$)/, '_1280'));
      })
      .catch(function () { span._vtFallback(); });
  });
})();
